import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 27.4 20.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.4 20.3\" id=\"arrow-right\"><g fill=\"none\" stroke-width=\"3\" stroke-miterlimit=\"10\"><path d=\"M16.1 1.1l9.2 9.1-9.2 9.1M0 10.2h25.4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol